import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import CouponService from "services/CouponService";

// Initial state for coupons slice
const initialState = {
  loading: false,
  coupons: [],
  coupon: {},
  message: "",
  showMessage: false,
};

// Async thunk to fetch coupons
export const getCoupons = createAsyncThunk(
  "coupons/getCoupons",
  async (_, { rejectWithValue }) => {
    try {
      const response = await CouponService.getCoupons();
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error fetching coupons");
    }
  }
);

export const getCoupon = createAsyncThunk(
  "coupons/getCoupon",
  async (couponId, { rejectWithValue }) => {
    try {
      const response = await CouponService.getCoupon(couponId);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error fetching coupon");
    }
  }
);

export const addCoupon = createAsyncThunk(
  "coupons/addCoupon",
  async (coupon, { rejectWithValue }) => {
    try {
      const response = await CouponService.addCoupon(coupon);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error adding coupon");
    }
  }
);

export const deleteCoupon = createAsyncThunk(
  "coupons/deleteCoupon",
  async (couponId, { rejectWithValue, dispatch }) => {
    try {
      const response = await CouponService.deleteCoupon(couponId);
      dispatch(getCoupons());
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error deleting coupon");
    }
  }
);

export const updateCoupon = createAsyncThunk(
  "coupons/updateCoupon",
  async ({ data, couponId }, { rejectWithValue }) => {
    try {
      const response = await CouponService.updateCoupon(data, couponId);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error updating coupon");
    }
  }
);

// Slice for coupons

const couponSlice = createSlice({
  name: "coupons",
  initialState,
  reducers: {
    clearMessage: (state) => {
      state.showMessage = false;
    },
  },
  extraReducers: {
    [getCoupons.pending]: (state) => {
      state.loading = true;
    },
    [getCoupons.fulfilled]: (state, action) => {
      state.loading = false;
      state.coupons = action.payload;
    },
    [getCoupons.rejected]: (state, action) => {
      state.loading = false;
      state.message = action.payload;
      state.showMessage = true;
    },
    [getCoupon.pending]: (state) => {
      state.loading = true;
    },
    [getCoupon.fulfilled]: (state, action) => {
      state.loading = false;
      state.coupon = action.payload;
    },
    [getCoupon.rejected]: (state, action) => {
      state.loading = false;
      state.message = action.payload;
      state.showMessage = true;
    },

    [addCoupon.pending]: (state) => {
      state.loading = true;
    },
    [addCoupon.fulfilled]: (state, action) => {
      state.loading = false;
      state.coupons.push(action.payload);
    },
    [addCoupon.rejected]: (state, action) => {
      state.loading = false;
      state.message = action.payload;
      state.showMessage = true;
    },
    [deleteCoupon.pending]: (state) => {
      state.loading = true;
    },
    [deleteCoupon.fulfilled]: (state, action) => {
      state.loading = false;
      state.coupons = state.coupons.filter(
        (coupon) => coupon.id !== action.payload
      );
    },
    [deleteCoupon.rejected]: (state, action) => {
      state.loading = false;
      state.message = action.payload;
      state.showMessage = true;
    },
    [updateCoupon.pending]: (state) => {
      state.loading = true;
    },
    [updateCoupon.fulfilled]: (state, action) => {
      state.loading = false;
      state.coupons = state.coupons.map((coupon) =>
        coupon.id === action.payload.id ? action.payload : coupon
      );
    },
    [updateCoupon.rejected]: (state, action) => {
      state.loading = false;
      state.message = action.payload;
      state.showMessage = true;
    },
  },
});

export const { clearMessage } = couponSlice.actions;
export default couponSlice.reducer;
